import React, { useState } from "react";
import { IoMdArrowRoundBack } from "react-icons/io";
import { toast } from "react-toastify";
import { newPasswordHandler } from "../../../service/AuthService";

const ResetPassword = ({ onFormChange }) => {
  const [newPassword, setNewPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleNewPasswordChange = (e) => {
    setNewPassword(e.target.value);
  };

  const email = localStorage.getItem("forgotPasswordEmail");

  const handleNewPassword = async () => {
    if (!newPassword) {
      toast.error("Please enter new password");
      return;
    }
    setIsLoading(true);
    try {
      await newPasswordHandler( email, newPassword );
      onFormChange("login");
      toast.success("Password Reset Successfully");
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const handleBack = () => {
    onFormChange("login");
  };

  return (
    <div class="my-auto mx-auto flex flex-col justify-center px-6 pt-8 md:justify-start lg:w-[28rem]">
      <p class="text-center text-3xl font-bold md:text-left md:leading-tight">
        New Password
      </p>
      <p class="mt-2 text-center text-gray-500 font-medium md:text-left">
        Enter your new password.
      </p>

      <div class="flex flex-col items-stretch pt-3 md:pt-8">
        <div class="flex flex-col pt-6">
          <div class="relative flex overflow-hidden rounded-md ">
            <input
              type="password"
              className="w-full py-3 px-4 text-sm text-gray-900 placeholder-gray-400 border-2 border-gray-200 focus:border-purple-500 focus:outline-purple rounded-lg"
              placeholder="New password"
              value={newPassword}
              onChange={handleNewPasswordChange}
            />
          </div>
        </div>

        <div className="flex items-center justify-between">
          <IoMdArrowRoundBack
            className="mt-6 text-2xl text-gray-400 cursor-pointer"
            onClick={handleBack}
          />
          <button
            type="submit"
            className="mt-6  rounded-lg bg-gray-800 px-4 py-2 text-center text-base font-semibold text-white shadow-md outline-none ring-gray-500 ring-offset-2 transition hover:bg-gray-900 focus:ring-2 md:w-32"
            onClick={handleNewPassword}
          >
            {isLoading ? "Resetting..." : "Reset Password"}
          </button>
        </div>
      </div>
    </div>
  );
};
export default ResetPassword;
